import axios from "./http";

export const getTeams = data => axios("teams", { params: data });
export const getTeam = data => axios(`teams/${data.id}`);
export const updateTeamByIDAPI = data => axios.put(`teams/${data.id}`, data);
export const deleteTeamByIDAPI = data => axios.delete(`teams/${data.id}`);

export const listTeamMembersAPI = (teamId, params) =>
  axios(`teams/${teamId}/members`, { params });
export const getTeamMembershipAPI = (teamId, username) =>
  axios(`teams/${teamId}/members/${username}`);
export const createTeamMemberAPI = (teamId, data) =>
  axios.post(`teams/${teamId}/members`, data);
export const updateTeamMemberAPI = (teamId, username, data) =>
  axios.put(`teams/${teamId}/members/${username}`, data);
export const deleteTeamMemberAPI = (teamId, username) =>
  axios.delete(`teams/${teamId}/members/${username}`);
